import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { Button, Chip, Link } from "@material-ui/core";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import styles from "assets/jss/material-kit-react/views/landingPageSections/adsStyle.js";


const useStyles = makeStyles(styles);

export default function Ads6() {
  const classes = useStyles();
  return (
    <div className={classes.bannerSection}>
      <div>
        <GridContainer justify="center" >
          <GridItem xs={10} sm={10} md={8}>
            <h2 className={classes.h2Title}>مسابقات برنامه نویسی آنلاین کمپ آموزشی شریف (TopDev)</h2>
            <br />
            <h5 className={classes.description}>
              یک مسابقه برنامه نویسی برای سنجش توانایی های برنامه نویسان بدون در نظر گرفتن زبان برنامه نویسی خاص که کلیه علاقمندان به برنامه نویسی بدون هیچ محدودیتی در زبان برنامه نویسی می توانند در این مسابقه شرکت کرده و نسبت به حل چالشهای <b>الگوریتمی</b> اقدام نمایند. مخاطب این رويداد تمامی کسانی هستند که توانایی برنامه نویسی دارند. فقط کافیست به یک زبان برنامه نویسی تسلط داشته باشيد تا بتوانيد در اين مسابقات شركت كنيد. </h5>
          </GridItem>
        </GridContainer>
        <br />
        <br />
        <GridContainer justify="center" >
          <GridItem xs={12} sm={12} md={12}>
            <GridContainer justify="center" >
            <GridItem xs={12} sm={12} md={2}>
              </GridItem>
              <GridItem xs={12} sm={12} md={2}>
                <a target='_blank' href='https://tpan.ir/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/tpan.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                </a>
              </GridItem>
              <GridItem xs={12} sm={12} md={2}>
                <a target='_blank' href='https://www.ustmb.ac.ir/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/ustmb1.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                </a>
              </GridItem>
              <GridItem xs={12} sm={12} md={2}>
                <a target='_blank' href='https://www.saminray.com/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/saminray.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                </a>
              </GridItem>
              
              <GridItem xs={12} sm={12} md={2}>
              </GridItem>
            </GridContainer>
            <br />
            <GridContainer justify="center" >
            <GridItem xs={12} sm={12} md={2}>
                <a target='_blank' href='https://trez.ir/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/trez.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                </a>
              </GridItem>
              <GridItem xs={12} sm={12} md={2}>
                <a target='_blank' href='https://www.xaas.ir/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/xaas1.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                </a>
              </GridItem>
            
              <GridItem xs={12} sm={12} md={2}>
                <a target='_blank' href='https://dayatadbir.com/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/dayatadbir.png"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                </a>
              </GridItem>
            </GridContainer>
            <div class={classes.ShowAll}>

              <Button className={classes.ActionButton} href="/TopDev/Enter" color="primary" variant="outlined" startIcon={<ArrowForwardIosIcon />}>
                ثبت نام و ورود به مسابقه
              </Button>
            </div>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
